import * as React from "react";
import Box from "@mui/material/Box";
import "./index.css";
import { Grid, Button } from "@mui/material";
import { CollectionSite, Place } from "../../../types";
import MapAutoComplete from "../../AutoComplete/MapAutoComplete";
import FormTextField from "../../TextFiled/FormTextField";
import AddressMap from "../AddressMap";
import MapIcon from "@mui/icons-material/Map";

interface Props {
  open: boolean;
  handleClose: () => void;
  handleSave: (data: CollectionSite) => void;
  formData: CollectionSite;
}

interface FormDataErrors {
  displayName: string;
  address: string;
  gps: string;
  description: string;
}

const CollectionCreationForm: React.FC<Props> = ({
  open,
  handleClose,
  handleSave,
  formData,
}) => {
  const [isMapModalOpen, setIsMapModalOpen] = React.useState<boolean>(false);
  const [data, setData] = React.useState<CollectionSite>(formData);
  const [errors, setErrors] = React.useState<FormDataErrors>({
    displayName: "",
    address: "",
    gps: "",
    description: "",
  });

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({
      ...data,
      [name]: value,
    });
    if (name === "gps") {
      if (!/^-?\d{2,}\.\d+, -?\d{2,}\.\d+$/.test(value) && value !== "") {
        setErrors((prev) => ({
          ...prev,
          gps: "Gps location Format should like 11.222, -11.222",
        }));
      } else {
        setErrors((prev) => ({ ...prev, gps: "" }));
      }
    }
  };

  const handleAddressSave = (address?: string) => {
    setData({
      ...data,
      address: address || "",
    });
  };

  const handleAddressSelect = (address?: Place) => {
    setData({
      ...data,
      address: address?.display_name || "",
      gps: address?.lat ? address?.lat + ", " + address?.lon : "",
    });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSave(data);
    handleClose();
  };

  return (
    <>
      {open && (
        <div className="modal-collection-site">
          <Box className="modal-content-collection-site">
            {/* <ChildModal /> */}
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                width: "100%",
              }}
            >
              <Grid container rowSpacing={1}>
                <FormTextField
                  name="displayName"
                  value={data.displayName}
                  handleChange={handleChange}
                  error={errors.displayName}
                  label="Display Name:"
                  required={true}
                />

                <Grid size={4} display="flex" alignItems="center">
                  Address:
                </Grid>
                <Grid size={8}>
                  <MapAutoComplete
                    initialValue={data.address}
                    handleInputChange={handleAddressSave}
                    handleSelect={handleAddressSelect}
                  />
                  <div className="btn-float-map-icon">
                    <Button
                      onClick={() => {
                        setIsMapModalOpen(true);
                      }}
                    >
                      <MapIcon />
                    </Button>
                  </div>
                </Grid>
                <FormTextField
                  name="gps"
                  value={data.gps}
                  handleChange={handleChange}
                  error={errors.gps}
                  label="GPS:"
                />

                <FormTextField
                  name="description"
                  value={data.description}
                  handleChange={handleChange}
                  error={errors.description}
                  label="Description:"
                />

                <Grid
                  size={6}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button variant="contained" type="submit">
                    Save
                  </Button>{" "}
                </Grid>
                <Grid
                  size={6}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </div>
      )}
      {isMapModalOpen && (
        <AddressMap
          open={isMapModalOpen}
          handleClose={() => {
            setIsMapModalOpen(false);
          }}
          initialValue={data.address}
          handleAddressSave={handleAddressSave}
          handleAddressSelect={handleAddressSelect}
        />
      )}
    </>
  );
};

export default CollectionCreationForm;
